export const getNestedValue = (obj, key) => {
  if (!key) return undefined;
  return key
    .split('.')
    .reduce(
      (acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined),
      obj
    );
};

const alphanumSort = (arr, property = 'name', order = 'asc') =>
  arr.sort((a, b) => {
    const valueA = getNestedValue(a, property)
      ?.toString()
      .trim()
      .toLowerCase();
    const valueB = getNestedValue(b, property)
      ?.toString()
      .trim()
      .toLowerCase();
    if (!valueA) return 1;
    if (!valueB) return -1;
    const comparison = valueA.localeCompare(valueB, undefined, {
      numeric: true
    });
    return order === 'asc' ? comparison : -comparison;
  });

export default alphanumSort;
